export enum UnitOptionUsePoint {
  Cost = 0,
  NoCost = 1,
  Free = 2,
  NoLimit = 3,
  UpTo = 4,
}
